.EventTile {
  display: flex;
  flex-direction: column;
  align-items: start;
  background: white;
  border: 1px solid #cccccc;
  border-radius: 1rem;
  overflow: hidden;
  transition:
    box-shadow 0.25s ease,
    transform 0.25s ease;

  &:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    transform: translateY(-3px);
  }

  & > a {
    width: 100%;
    height: 24rem;
    display: flex;
    flex-direction: column;
    text-decoration: none;

    & > :global(.image) {
      display: flex;
      justify-content: space-between;
      align-items: start;
      padding: 1rem;
      background-size: cover;
      background-position: center;
      height: 10rem;
      width: 100%;
      transition: transform 0.35s ease;

      & > :global(.eventType) {
        color: rgb(0 0 0 / var(--tw-text-opacity, 1));
        font-size: 0.875rem;
        line-height: 1.25rem;
        padding: 0.25rem 0.75rem;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
        border-radius: 9999px;
      }

      & > :global(.cheapestPrice) {
        color: rgb(0 0 0 / var(--tw-text-opacity, 1));
        font-size: 0.875rem;
        line-height: 1.25rem;
        padding: 0.25rem 0.75rem;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
        border-radius: 9999px;
      }
    }

    &:hover > :global(.image) {
      transform: scale(1.08);
    }

    & > :global(.main) {
      flex-direction: column;
      flex-grow: 1;
      display: flex;
      padding: 1rem 1rem;
      gap: 0.75rem;

      & > h2 {
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 130%;
        color: black;
      }

      & > :global(.description),
      & > :local(.description) {
        font-size: 0.9rem;
        color: #4d4d4d;
        line-height: 120%;
        margin-bottom: 0.5rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;

        & p,
        & ul,
        & ol {
          margin: 0;
          padding: 0;
        }

        & ul,
        & ol {
          padding-left: 1.1rem;
        }

        & li + li {
          margin-top: 0.1rem;
        }

        & a {
          color: inherit;
          text-decoration: none;
          pointer-events: none;
        }
      }

      & > :global(.bottom) {
        display: flex;
        flex-wrap: wrap;
        gap: 0.75rem;
        justify-content: space-between;
        align-items: center;
        margin-top: auto;

        & > :global(.ticketsLeft) {
          display: flex;
          flex-shrink: 0;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
          line-height: 1.25rem;

          @media (min-width: 1025px) {
            font-size: 1rem;
            line-height: 1.5rem;
          }

          & > img {
            width: 1rem;
            height: 1rem;

            @media (min-width: 1025px) {
              width: 1.25rem;
              height: 1.25rem;
            }
          }

          & > span {
            font-size: 0.9rem;
            font-weight: 600;
            color: #034026;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        & > :global(.startDate) {
          font-size: 0.9rem;
          background-color: #034026;
          color: white;
          padding: 0.1rem 0.7rem;
          border-radius: 1rem;
          font-size: 0.875rem;
          line-height: 1.25rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          flex-shrink: 0;

          @media (min-width: 1025px) {
            font-size: 1rem;
            line-height: 1.5rem;
          }
        }
      }
    }
  }
}

.EventTileIcons {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}
